<template>
  <img :src="`https://stadiamaps.com/static/outdoors?api_key=23fe682b-ac7c-4f2b-83db-39dcf2a8b9ac&center=27,10&zoom=0${markerString}&size=512x265@2x`" alt="World map" />
</template>

<script setup lang="ts">
import {
  PropType, watch, ref,
} from 'vue';
import debounce from '@/common/debounce';

export interface Marker {
  lat: number;
  lon: number;
  variant: string | true | null;
}

const props = defineProps({
  markers: {
    type: Array as PropType<Array<Marker>>,
    required: true,
  },
});

const markerString = ref('');

const debouncedUpdateMarkers = debounce(() => {
  markerString.value = props.markers.map((marker) => `&m=${marker.lat},${marker.lon},osm_bright,f87171${marker.variant === true ? ',,' : `,${marker.variant},fff`}`).join();
}, 100);

watch(() => props.markers, () => {
  if (props.markers.length === 8) {
    // Don't wait 100ms if we have all the markers
    markerString.value = props.markers.map((marker) => `&m=${marker.lat},${marker.lon},osm_bright,f87171${marker.variant === true ? ',,' : `,${marker.variant},fff`}`).join();
  } else {
    debouncedUpdateMarkers();
  }
});
</script>
